import React, { useState, useRef, useEffect, useContext } from "react";
import "./Image_Swiper.css";
import Common_Title from "../../../common_component/common_title/Common_Title";
import { getData } from "../../../../utils/api";
import { Context } from "../../../../utils/context";

const mainImages = [
  "/assets/images/cruise/cruise details/cruise-description/boat-swiper-img.png",
  "/assets/images/cruise/cruise details/cruise-description/boat-swiper-img.png",
  "/assets/images/cruise/cruise details/cruise-description/boat-swiper-img.png",
  "/assets/images/cruise/cruise details/cruise-description/boat-swiper-img.png",
];
const images = [
  "/assets/images/cruise/cruise details/cruise-description/img1.png",
  "/assets/images/cruise/cruise details/cruise-description/card1.png",
  "/assets/images/cruise/cruise details/cruise-description/img1.png",
  "/assets/images/cruise/cruise details/cruise-description/card1.png",
  "/assets/images/cruise/cruise details/cruise-description/img1.png",
];

function ImageSwiper({ data }) {
  const [mainImage, setMainImage] = useState();
  const thumbRef = useRef();

  const scrollUp = () => {
    thumbRef.current.scrollBy({
      top: -220,
      behavior: "smooth",
    });
  };

  const scrollDown = () => {
    thumbRef.current.scrollBy({
      top: 220,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setMainImage(data?.images?.[0]?.image);
  }, [data]);

  const { IMG_URL } = useContext(Context);
  return (
    <section className="cruise_details_section">
      <div className="container">
        <div className="cruise_header">
          <div className="title_with_badge">
            <Common_Title title={data?.title} />

            <span className="night_badge">{data?.duration}</span>

            {/* <span className="share_icon">
              <i className="fa-solid fa-share-nodes"></i>
            </span> */}
          </div>
          <p className="sub_title">
            Departing:- <strong>{data?.departed}</strong> &nbsp; Visiting:-
            <strong>{data?.visiting}</strong> &nbsp; Ship:-{" "}
            <strong>{data?.itineraries?.[0]?.transfer_type} </strong>
          </p>
        </div>

        <div className="row gallery_row">
          {/* MAIN IMAGE */}
          <div className="col-lg-8">
            <div className="main_cruise_img">
              <img src={mainImage} alt="Cruise" />
            </div>
          </div>

          {/* THUMBNAILS */}
          <div className="col-lg-4">
            <div className="thumb_scroller">
              <button className="scroll_btn up" onClick={scrollUp}>
                <i className="fa-solid fa-chevron-up"></i>
              </button>

              <div className="thumb_container" ref={thumbRef}>
                {data?.images?.map((img, index) => (
                  <div
                    key={index}
                    className="thumb_img"
                    onClick={() => setMainImage(img)}
                  >
                    <img src={img?.image} alt="thumb" />
                  </div>
                ))}
              </div>

              <button className="scroll_btn down" onClick={scrollDown}>
                <i className="fa-solid fa-chevron-down"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ImageSwiper;
